export enum SPARE_PART_SUPPLIER_DOMAIN {
  LIST = 'list',
  BY_SELLER_ID = 'bySellerId',
}

export const SPARE_PART_SUPPLIER_DOMAIN_KEY = 'sparePartSupplier';
